import React, { useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

interface IScratchPayPollingScreenProps {
  onLeave: () => void;
}

export const ScratchPayPollingScreen = ({ onLeave }: IScratchPayPollingScreenProps) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleBackClick = () => {
    setIsConfirmOpen(true);
  };

  const handleStay = () => {
    setIsConfirmOpen(false);
  };

  const handleLeave = () => {
    setIsConfirmOpen(false);
    onLeave();
  };

  return (
    <Box className="w-full h-full flex flex-col justify-center items-center px-4">
      <img
        src="/assets/icons/Foxhound_Loading.gif"
        className="w-96 max-w-full"
        alt="Loading"
      />

      <Typography variant="h4" sx={{ fontWeight: 600, textAlign: "center", mt: 2 }}>
       You’re heading to Scratch, GoodVets monthly subscription partner.
      </Typography>
      <Typography variant="body1" sx={{ textAlign: "center", mt: 1, maxWidth: "36rem" }}>
        Watch for your one-time passcode to continue securely.
      </Typography>

      <Button
        variant="outlined"
        color="primary"
        sx={{ mt: 3 }}
        onClick={handleBackClick}
      >
        Back to Pet Care
      </Button>

      <Dialog
        open={isConfirmOpen}
        onClose={handleStay}
        aria-labelledby="scratchpay-leave-page-title"
        aria-describedby="scratchpay-leave-page-description"
      >
        <DialogTitle id="scratchpay-leave-page-title">Leave this page?</DialogTitle>
        <DialogContent>
          <Typography id="scratchpay-leave-page-description" variant="body2">
            If you leave this page, you will interrupt the ScratchPay payment process.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleStay} color="primary" variant="contained">
            Stay on this page
          </Button>
          <Button onClick={handleLeave} color="primary" variant="text">
            Leave anyway
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};


